export interface Utente {
  id: number | null;
  email: string;
}

export const UtenteVuoto =
{
  id: null,
}

export type Align = 'right' | 'left' | 'center';


export const THeadUsers = [
  { id: "email", label: "Email", width: "200px" },
  { id: "start_date", label: "Registrato il", width: "200px" },
  { id: "actions", label: "", width: "80px" },
  //{ 
  //  id: "autenticationIcon", 
  //  label: "Autenticazione",
  //  renderCell: (row: any) => row.autenticationIcon || null
  //},
];
